var exports = {
  "P": "IconButton_0__SSIi47",
};

module.exports = exports;
